import { createContext } from 'react';

var FlexGridContext = createContext({
  gutter: 0
});

export { FlexGridContext };
//# sourceMappingURL=FlexGridContext.js.map
